/**
 * shared/collision/testworlds.ts — dev/test worlds selectable per room (RoomSettings.testWorld,
 * URL ?world=flat). Lets pmove/weapons/bots be tested in the browser before the real Hijacked
 * collision exists. Server and client both build the world from the same name -> same bits.
 * OWNER: collision agent (may add worlds; keep 'flat').
 */
import { createFlatWorld, BoxWorld } from './boxworld';
import type { CollisionWorld } from './types';
import { CONTENTS } from './types';

export type TestWorldName = 'flat' | 'steps';

/** Lowest Hijacked mp_dm_spawn z is -64: the flat floor sits there so every spawn is above it. */
export const TEST_FLOOR_Z = -64;

export function createTestWorld(name: TestWorldName): CollisionWorld {
  if (name === 'steps') {
    // flat floor + a stair (8 x 16u steps) + an 18u and a 19u ledge + a 45deg-ish wall block
    const w = new BoxWorld('steps').box([-65536, -65536, TEST_FLOOR_Z - 64], [65536, 65536, TEST_FLOOR_Z], CONTENTS.SOLID, 5 << 20);
    for (let i = 0; i < 8; i++) w.box([200 + i * 16, -64, TEST_FLOOR_Z], [400, 64, TEST_FLOOR_Z + 16 * (i + 1)]);
    w.box([-300, 200, TEST_FLOOR_Z], [-200, 300, TEST_FLOOR_Z + 18]);
    w.box([-300, 400, TEST_FLOOR_Z], [-200, 500, TEST_FLOOR_Z + 19]);
    return w;
  }
  return createFlatWorld(TEST_FLOOR_Z);
}
